// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"2c6adcbc","338":"217958e0","645":"f6bcde8a","883":"9bf4bf35"}[chunkId] + ".chunk.js";
};